<!-- Patient Data Missing Warning -->
@if (hasPatientDataError) {
  <div class="alert alert-warning mt-n1">
    <strong>WARNING!</strong> Patient context is not available.
    <br />
    <strong>Received Issuer:</strong> {{ receivedIss || 'Not provided' }}
    <br />
    <strong>Received Patient ID:</strong> {{ receivedPatientId || 'Not provided' }}
    <br />
    Please ensure the application is launched from the EHR with a valid patient context and try again.
  </div>
}

<!-- Show content only if patient data is available -->
@if (!hasPatientDataError) {
  <div>
    @if (cibmtrPatientCount > 1) {
      <div class="alert alert-warning mt-n1">
        <strong>WARNING!</strong> A duplicate patient resource has been identified for this patient.
        <br />
        It is necessary to correct this before proceeding further.
        <br />
        Please open a ticket through <a href="https://nmdp.servicenow.com" target="_blank">NMDP ServiceNow</a> to report this issue, and include the assigned CRID for this patient.
      </div>
    }
    <div class="container">
      <div class="welcome-text">
        Welcome {{ dataManagerName }} from {{ selectedCenterName }}
      </div>
    </div>
    <div class="container">
      @if (ehrpatient) {
        <div class="patient-card">
          <div class="row mb-3">
            <div class="col-md-6 patient-name">
              {{ patientName }}
            </div>
            <div class="col-md-6 patient-crid">
              @if (crid$ | async) {
                <div>
                  @if (crid) {
                    <div>
                      <span class="research-id-text">CIBMTR Research ID (CRID) : </span>
                      <span>{{ crid }}</span>
                    </div>
                  } @else {
                    <button class="btn btn-primary register" type="button" (click)="register($event, ehrpatient)"
                      [disabled]="isLoading">
                      @if (isLoading) {
                        <img id="spinner" src="assets/spinner.gif" />
                      }
                      Associate Crid
                    </button>
                  }
                </div>
              }
            </div>
          </div>
          <div class="space-y-2 mb-4">
            <!-- SSN Warning -->
            @if (ssnIdentifier?.length > 0 && !isValidSsn) {
              <div class="text-danger items-center gap-2 bg-blue-200 p-2 rounded text-sm">
                <span>
                  <strong>Warning:</strong> Invalid SSN <strong class="font-semibold">{{ ssn }}</strong> will not be used for CRID registration
                </span>
              </div>
            }
            <!-- Race Warning -->
            @if (hasinvalidraceCodes) {
              <div class="text-danger items-center gap-2 bg-blue-200 p-2 rounded text-sm">
                <span>
                  <strong>Warning:</strong> Provided Race will not be considered for CRID registration.
                </span>
              </div>
            }
          </div>
          <ul>
            <li>Date of birth: {{ ehrpatient.birthDate }}</li>
            <li>Gender: {{ ehrpatient.gender }}</li>
            <li>Identifiers:</li>
            @for (identifier of nonPIIIdentifiers; track identifier) {
              <ul>
                <li>{{ identifier.type?.text }}:{{ identifier.value }}</li>
              </ul>
            }
          </ul>
        </div>
      }
      <div class="row float-end">
        @if (crid && isCibmtrCallSuccess) {
          <div class="col-12">
            <button type="button" class="btn btn-primary register_proceed" (click)="proceed()">
              Proceed
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
